/* RAREITEM theme — vanilla JS เท่านั้น ไม่มี dependency */
(function () {
  'use strict';

  /* ── Accordion (หน้าโปรดักต์) ── */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
  });

  /* ── ปุ่ม +/− จำนวนสินค้า ── */
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input[type="number"]');
    if (!input) return;
    box.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.dataset.step, 10);
        var min = parseInt(input.min || '1', 10);
        var val = Math.max(min, (parseInt(input.value, 10) || min) + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ── ตะกร้า: เปลี่ยนจำนวนแล้ว submit ฟอร์มอัปเดต ── */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () { cartForm.submit(); });
    });
  }

  /* ── แกลเลอรีสินค้า: คลิก thumbnail สลับรูปหลัก ── */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.dataset.src;
        main.srcset = thumb.dataset.srcset || '';
        main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
      });
    });
  });

  /* ── Variant picker: radio → hidden select[name=id] + อัปเดตราคา/ปุ่ม ── */
  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var jsonEl = wrapper.querySelector('[data-variants-json]');
    var idInput = wrapper.querySelector('[name="id"]');
    if (!jsonEl || !idInput) return;
    var variants = JSON.parse(jsonEl.textContent);
    var money = function (cents) {
      return '฿' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
    };

    function currentOptions() {
      var opts = [];
      wrapper.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts[parseInt(group.dataset.optionIndex, 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function onChange() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var priceNow = wrapper.querySelector('[data-price]');
      var priceWas = wrapper.querySelector('[data-compare-price]');
      var offTag = wrapper.querySelector('[data-off]');
      var addBtn = wrapper.querySelector('[data-add-button]');
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'ไม่มีตัวเลือกนี้'; }
        return;
      }
      idInput.value = match.id;
      if (priceNow) priceNow.textContent = money(match.price);
      if (priceWas) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceWas.textContent = money(match.compare_at_price);
          priceWas.hidden = false;
          if (offTag) {
            offTag.textContent = '-' + Math.round((1 - match.price / match.compare_at_price) * 100) + '%';
            offTag.hidden = false;
          }
        } else {
          priceWas.hidden = true;
          if (offTag) offTag.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
      }
      var sticky = document.querySelector('[data-sticky-price]');
      if (sticky) sticky.textContent = money(match.price);
    }

    wrapper.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', onChange);
    });
  });

  /* ── Collection: sort + toggle ตัวกรองบนมือถือ + auto-submit ฟิลเตอร์ ── */
  var sortSel = document.querySelector('[data-sort-by]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      url.searchParams.delete('page');
      window.location.href = url.href;
    });
  }
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      var open = filterPanel.classList.toggle('open');
      filterToggle.setAttribute('aria-expanded', String(open));
    });
  }
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', function () { filterForm.submit(); });
    });
  }

  /* ── วัดความสูงแถบประกาศ เก็บไว้ใน --annh ให้ header sticky วางต่อได้พอดี ── */
  var annBar = document.querySelector('.announce');
  if (annBar) {
    var setAnnH = function () {
      document.documentElement.style.setProperty('--annh', (annBar.offsetHeight || 0) + 'px');
    };
    setAnnH();
    window.addEventListener('resize', setAnnH, { passive: true });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(setAnnH); }
    document.addEventListener('shopify:section:load', setAnnH);
    document.addEventListener('shopify:section:unload', setAnnH);
    if ('ResizeObserver' in window) { new ResizeObserver(setAnnH).observe(annBar); }
  }

  /* ── วัดความสูงหัวเว็บ เก็บไว้ใน --headh ให้ของที่ sticky ตัวอื่น (แถบกรอง, กล่องสรุป)
       เกาะใต้หัวเว็บพอดี ไม่มุดเข้าไปอยู่หลังมัน ── */
  var headBar = document.querySelector('header.site');
  if (headBar) {
    var setHeadH = function () {
      document.documentElement.style.setProperty('--headh', (headBar.offsetHeight || 0) + 'px');
    };
    setHeadH();
    window.addEventListener('resize', setHeadH, { passive: true });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(setHeadH); }
    document.addEventListener('shopify:section:load', setHeadH);
    document.addEventListener('shopify:section:unload', setHeadH);
    if ('ResizeObserver' in window) { new ResizeObserver(setHeadH).observe(headBar); }
  }

  /* ── Sticky header: ใส่เงาตอนเริ่มเลื่อน (ตัว sticky ทำด้วย CSS แล้ว) ── */
  var stickyHeader = document.querySelector('header.site');
  if (stickyHeader) {
    var stuckTick = false;
    var updateStuck = function () {
      stickyHeader.classList.toggle('is-stuck', window.scrollY > 2);
      stuckTick = false;
    };
    window.addEventListener('scroll', function () {
      if (!stuckTick) { stuckTick = true; requestAnimationFrame(updateStuck); }
    }, { passive: true });
    updateStuck();
  }
})();
